import type {DashboardBreakdownRow, DashboardBreakdowns} from "../types";
import {BreakdownBarList} from "./breakdown-bar-list";
import {DarsSeverityBreakdown} from "./dars-severity-breakdown";

type BreakdownsSectionProps = {
  breakdowns: DashboardBreakdowns;
};

function asRowList(value: unknown): DashboardBreakdownRow[] {
  return Array.isArray(value) ? (value as DashboardBreakdownRow[]) : [];
}

export function BreakdownsSection({breakdowns}: BreakdownsSectionProps) {
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
      <DarsSeverityBreakdown data={breakdowns.dars_by_severity} />
      <BreakdownBarList
        title="Incidents by type"
        rows={asRowList(breakdowns.incident_reports_by_type)}
      />
      <BreakdownBarList
        title="Dispatch by type"
        rows={asRowList(breakdowns.dispatch_logs_by_type)}
      />
      <BreakdownBarList
        title="Citations by type"
        rows={asRowList(breakdowns.citations_by_type)}
      />
    </div>
  );
}
